import { Dialog } from "radix-ui";
import { CloseIcon } from "../../../../../icons";

const LinkAddDialogHeader = ({ onClose }: { onClose: () => void }) => {
  return (
    <Dialog.Title>
      <div className="flex items-center justify-between py-[8px] pl-[15px] pr-[10px]">
        <span className="text-[14px] font-normal leading-[1.5em] text-white">Link</span>
        <Dialog.Close asChild>
          <button
            onClick={onClose}
            className="flex h-6 w-6 items-center justify-center rounded-[5px] text-80 transition duration-200 hover:bg-w-8-hover hover:text-white"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </Dialog.Close>
      </div>
    </Dialog.Title>
  );
};

export default LinkAddDialogHeader;
